var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnterRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.92931 4.624L5.63331 3.92L9.72931 8L5.63331 12.08L4.92931 11.376L7.80931 8.496H0.945312V7.504H7.80931L4.92931 4.624ZM10.3853 2H15.0573V14H10.3853V2ZM2.06531 0.992V3.504H1.05731V0.992C1.05731 0.714667 1.15331 0.48 1.34531 0.288C1.54798 0.096 1.78798 0 2.06531 0H16.0653C16.3426 0 16.5773 0.096 16.7693 0.288C16.9613 0.48 17.0573 0.714667 17.0573 0.992V15.008C17.0573 15.2747 16.9613 15.504 16.7693 15.696C16.5773 15.8987 16.3426 16 16.0653 16H2.06531C1.78798 16 1.54798 15.904 1.34531 15.712C1.15331 15.52 1.05731 15.2853 1.05731 15.008V12.496H2.06531V15.008H16.0653V0.992H2.06531Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterRight);
export default __webpack_public_path__ + "static/media/enter-right.6d406ea4f3da6676eaa4655719ecde53.svg";
export { ForwardRef as ReactComponent };